import { render, staticRenderFns } from "./smsHistory.vue?vue&type=template&id=afcffe52"
import script from "./smsHistory.vue?vue&type=script&lang=js"
export * from "./smsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports